module.exports = __webpack_public_path__ + "img/qrespi-framework-v03.df4951c1.svg";